document.addEventListener("DOMContentLoaded", () => {
  const scripts = document.querySelectorAll('.ProductListData');

  scripts.forEach((scriptTag, index) => {

    const parent = scriptTag.parentElement;

    const container = parent.querySelector('.group-block:last-child .group-block-content');

    if (!container) {
      console.warn('Stopped: Could not find .group-block-content inside the parent.');
      return;
    }

    // Parse JSON
    let products = [];
    try {
      products = JSON.parse(scriptTag.textContent);
    } catch (e) {
      console.error('Stopped: JSON parsing failed.', e);
      return;
    }

    // Shuffle
    for (let i = products.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [products[i], products[j]] = [products[j], products[i]];
    }

    const cards = container.querySelectorAll(':scope > .group-block');

    const randomFour = products.slice(0, 4);

    // Replace data
    // Replace data
    randomFour.forEach((product, cardIndex) => {
      if (!cards[cardIndex]) return;

      const titleEl = cards[cardIndex].querySelector('h4');
      const descEl = cards[cardIndex].querySelector('p');
      const formVariantId = cards[cardIndex].querySelector('[name="id"]');
      const formProductId = cards[cardIndex].querySelector('[name="product-id"]');
      const cardProductTitle = cards[cardIndex].querySelector('quick-add-component');
      const cardProductId = cards[cardIndex].querySelector('product-form-component');
      const parentIndex = cards[cardIndex].querySelector('product-card');
      const cardGalleryId = cards[cardIndex].querySelector('card-gallery');

      // Links and URL-driven components
      const productCardLink = cards[cardIndex].querySelector('[ref="productCardLink"]');
      const cardGalleryLink = cards[cardIndex].querySelector('[ref="cardGalleryLink"]');
      const productTitleLink = cards[cardIndex].querySelector('[ref="productTitleLink"]');
      const variantPicker = cards[cardIndex].querySelector('swatches-variant-picker-component');

      // Note: Using the tag name 'slideshow-slides' instead of the class '.slideshow-slides' 
      // since your HTML snippet shows it as a custom HTML tag without that specific class.
      const imageSlideshow = cards[cardIndex].querySelector('slideshow-slides');

      if (titleEl) titleEl.textContent = product.title;
      if (descEl) descEl.innerHTML = product.description;
      if (formVariantId) formVariantId.value = product.variant_id;
      if (formProductId) formProductId.value = product.id;
      if (cardProductId) cardProductId.dataset.productId = product.id;
      if (cardProductTitle) cardProductTitle.dataset.productTitle = product.title;
      if (parentIndex) parentIndex.dataset.productId = product.id;
      if (cardGalleryId) cardGalleryId.dataset.productId = product.id;

      // Ensure all product links and URL-based behaviors point to the new product
      if (product.url) {
        if (productCardLink instanceof HTMLAnchorElement) {
          productCardLink.href = product.url;
        }
        if (cardGalleryLink instanceof HTMLAnchorElement) {
          cardGalleryLink.href = product.url;
        }
        if (productTitleLink instanceof HTMLAnchorElement) {
          productTitleLink.href = product.url;
        }
        if (variantPicker) {
          variantPicker.dataset.productUrl = product.url;
        }
      }

      // --- Image Replacement Logic ---
      if (imageSlideshow && product.images && product.images.length > 0) {
        // 1. Get the current slides in this specific card
        const existingSlides = Array.from(imageSlideshow.querySelectorAll('slideshow-slide'));

        // Safety check: ensure we have at least one slide to clone from
        if (existingSlides.length === 0) return;

        product.images.forEach((imageUrl, imgIndex) => {
          let slide;

          if (imgIndex < existingSlides.length) {
            // Option A: An existing slide is available, let's reuse it
            slide = existingSlides[imgIndex];
          } else {
            // Option B: We need more slides! Clone the first slide to use as a template
            slide = existingSlides[0].cloneNode(true);

            // Update the view-timeline-name so the CSS scroll snapping doesn't break
            slide.style.viewTimelineName = `--slide-${imgIndex + 1}`;

            // Append the new slide to the slideshow
            imageSlideshow.appendChild(slide);
          }

          // 2. Update the image tags inside the slide
          const imgEl = slide.querySelector('img');
          if (imgEl) {
            imgEl.src = imageUrl;

            // CRITICAL: Remove the srcset or the browser will still show the old image
            imgEl.removeAttribute('srcset');

            // Update other relevant attributes
            imgEl.setAttribute('data_max_resolution', imageUrl);
            imgEl.alt = product.title;
          }
        });

        // 3. Clean up: What if the old product had 5 images, but the new one only has 2?
        // We need to remove the leftover existing slides.
        if (product.images.length < existingSlides.length) {
          for (let i = product.images.length; i < existingSlides.length; i++) {
            existingSlides[i].remove();
          }
        }
      }
    });
  });
});